<template v-once>
  <ul class="social-widget greet__social">
    <li>
      <a
        :href="links.facebook"
        target="_blank"
        rel="nofollow me noopener noreferrer"
      >
        <i class="iconmoon-facebook"></i>
      </a>
    </li>
    <li>
      <a
        :href="links.youtube"
        target="_blank"
        rel="nofollow me noopener noreferrer"
      >
        <i class="iconmoon-youtube-play"></i>
      </a>
    </li>
    <li>
      <a
        :href="links.twitter"
        target="_blank"
        rel="nofollow me noopener noreferrer"
      >
        <i class="iconmoon-twitter"></i>
      </a>
    </li>
    <li>
      <a :href="links.vk" target="_blank" rel="nofollow me noopener noreferrer">
        <i class="iconmoon-vk"></i>
      </a>
    </li>
  </ul>
</template>

<script>
import links from "../../data/links";

export default {
  data() {
    return {
      links
    };
  }
};
</script>
